export const categories = {
  1379: {
    name: 'Back-End',
    slug: 'back-end',
  },
  1362: {
    name: 'Carreira',
    slug: 'carreira',
  },
  1382: {
    name: 'CSS',
    slug: 'css',
  },
  1363: {
    name: 'Cultura Tech',
    slug: 'cultura-tech',
  },
  1378: {
    name: 'Front-End',
    slug: 'front-end',
  },

  1383: {
    name: 'HTML',
    slug: 'html',
  },
  1364: {
    name: 'Institucional',
    slug: 'institucional',
  },
  1384: {
    name: 'Javascript',
    slug: 'javascript',
  },
  1366: {
    name: 'Mercado de Trabalho',
    slug: 'mercado-de-trabalho',
  },
  1381: {
    name: 'Programação',
    slug: 'programacao',
  },
  1367: {
    name: 'Tecnologia',
    slug: 'tecnologia',
  },
  1385: {
    name: 'Python',
    slug: 'python',
  },
  1: {
    name: 'Uncategorized',
    slug: 'uncategorized',
  },
};
